import script from "./NewsPageBodyPostBody.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPostBody.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPostBody.vue?vue&type=style&index=0&id=e22c38ee&scoped=true&lang=scss"
import "./NewsPageBodyPostBody.vue?vue&type=style&index=1&id=e22c38ee&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e22c38ee"]])

export default __exports__